import React, { useState } from 'react';
import FlagJa from '../images/common/flag_ja.png';
import FlagJa2x from '../images/common/flag_ja@2x.png';
import { ReactComponent as IconLicense } from '../images/common/license.svg';
import { ReactComponent as IconFlask } from '../images/common/triangle-flask.svg';
import { ReactComponent as IconInfo } from '../images/common/icon-info.svg';
import './IconGuide.scss';

const IconGuide = () => {
  const [ showModal, setShowModal ] = useState(false);

  return (
    <>
      <div className="icon-guide-link">
        <button type="button" onClick={ () => setShowModal(true) }><IconInfo />アイコンの見方</button>
      </div>
      { showModal && (
        <section className="icon-guide-modal">
          <div className="modalbg" onClick={ () => setShowModal(false) }></div>
          <div className="modalwrapper">
            <div>
              <h2 className="sec_title">アイコンの見方</h2>
              <dl className="icon-guide-list">
                <dt>
                  <img
                    className="flag-ja"
                    src={ FlagJa }
                    srcSet={ `${ FlagJa } 1x, ${ FlagJa2x } 2x` }
                    alt="日本"
                  />
                </dt>
                <dd>日本国籍の日本人</dd>
                <dt>
                  <div className="cert-badge certified">
                    <IconLicense />
                  </div>
                </dt>
                <dd>本人確認済み</dd>
                <dt>
                  <div className="cert-badge certified">
                    <IconFlask />
                  </div>
                </dt>
                <dd>性病検査済み</dd>
                <dt>
                  <div className="cert-badge text certified">A</div>
                </dt>
                <dd>精子品質（A〜Eの5段階）</dd>
              </dl>
              <div className="closemodal" onClick={ () => setShowModal(false) }>×</div>
            </div>
          </div>
        </section>
      ) }
    </>
  );
};

export default IconGuide;
